require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./shot-do-not-remove.json") })
        }
      }, "path---shot-do-not-remove");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---shot-do-not-remove!./.cache/json/shot-do-not-remove.json
// module id = 913
// module chunks = 231608221292675